import React from 'react'
import Auth0ProviderWithHistory from '../../Auth0ProviderWithHistory'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { RouterContextProvider } from 'components/router/context/RouterContextProvider'
import { PresentSprintPacket } from 'pages/business/sprint-packets/PresentSprintPacket'
import { ReviewSprintPacket } from 'pages/business/sprint-packets/ReviewSprintPacket'
import { Login } from 'pages/auth/login'
import { InvalidUser } from 'pages/auth/login/InvalidUser'
import { useAuth0 } from '@auth0/auth0-react'
import { sessionService } from '@marketing-milk/frontend'

// `Login` sends an already-authenticated user back to the first route they
// visited this session (`routes[0]`) — fine for the full `Router`, where
// every route is reachable, but for this cohort any URL outside the Switch
// below would bounce back here and re-loop through `/login` forever. Render
// inline instead of redirecting anywhere.
const PageUnavailable = () => {
  const { logout: auth0Logout } = useAuth0()

  function logoutUser() {
    const redirectURL = `${window.location.origin}/builder/login`
    // Deliberately NOT the session context's reactive `logout()` — that also
    // calls `setUser(undefined)`, which flips `App.tsx` to the full `Router`
    // and mounts `Login` in THIS tab while `auth0Logout` below is still
    // navigating away. `Login`'s own effect then races it with its own
    // silent-auth attempt against the not-yet-cleared Auth0 SSO cookie, and
    // when it wins, the user gets silently logged back in instead of
    // reaching the Auth0 login form. `sessionService.logout()` clears the
    // same local token/header without touching React state, so nothing
    // re-renders here — the only thing that happens is the one navigation
    // below.
    sessionService.logout()
    auth0Logout({ returnTo: redirectURL })
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: '100vh',
      }}
    >
      <h1>Hi,</h1>
      <div>
        This page isn't available on your account. To login with another account, click{' '}
        <a onClick={logoutUser} style={{ cursor: 'pointer' }}>
          here
        </a>
      </div>
    </div>
  )
}

// The route table for users holding only `AccessPacketReview` (no
// `AccessAdBuilderApp`). Deliberately small and separate from `Router` — per
// DRI-75, every other builder route being unreachable here is the security
// boundary for this permission, not a guard on each individual route.
export function ClientRouter() {
  return (
    <BrowserRouter basename="/builder">
      <RouterContextProvider>
        <Auth0ProviderWithHistory>
          <Switch>
            <Route exact path="/:businessID/sprint-packets/:packetID/present">
              <PresentSprintPacket />
            </Route>
            <Route exact path="/:businessID/sprint-packets/:packetID/review">
              <ReviewSprintPacket />
            </Route>

            <Route path="/login">
              <Login />
            </Route>
            <Route path="/invalid_user">
              <InvalidUser />
            </Route>
            <Route>
              <PageUnavailable />
            </Route>
          </Switch>
        </Auth0ProviderWithHistory>
      </RouterContextProvider>
    </BrowserRouter>
  )
}
